import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=2f2dce7b&scoped=true&"
import script from "./blackList.vue?vue&type=script&lang=js&"
export * from "./blackList.vue?vue&type=script&lang=js&"
import style0 from "./blackList.vue?vue&type=style&index=0&id=2f2dce7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2dce7b",
  null
  
)

export default component.exports